"use client";
import { useState, useEffect, useRef } from "react";
import {
  Card,
  Input,
  Select,
  Radio,
  Button,
  Typography,
  Grid,
  DatePicker,
} from "antd";
import {
  CloseCircleOutlined,
  EllipsisOutlined,
  PlusOutlined,
  StarFilled,
  StarOutlined,
} from "@ant-design/icons";
import PropTypes from "prop-types";
import {
  EditOutlined,
  FileSearchOutlined,
  FileTextOutlined,
  SolutionOutlined,
  ScissorOutlined,
  ClockCircleOutlined,
  SearchOutlined,
  CloseOutlined,
  MedicineBoxOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { useAuth } from "../../services/authentication_API/authService";
import { updatemedicine } from "../../services/doctor/medicine/medicine";
import { useMessageApi } from "../../services/message api/MessageProvider";
import AlternateTimingUI from "./SwitchUI1";

const { TextArea } = Input;
const { Option } = Select;
const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

const MedicalForm = ({
  type,
  title,
  subtitle,
  onDataChange,
  formdata,
  goToNextSection,
}) => {
  const screens = useBreakpoint();
  const [formData, setFormData] = useState(null);
  const [selectedDoseIndex, setSelectedDoseIndex] = useState(0);
  console.log("Form Data:", formdata);
  const [selectedMeals, setSelectedMeals] = useState([]);
  const { userData } = useAuth();
  const messageApi = useMessageApi();
  const [doseSaved, setDoseSaved] = useState(formdata?.is_save);
  const prevFormData = useRef(null);
  const [showAlternateTiming, setShowAlternateTiming] = useState(formdata?.type_unit_ui=="Alternate" ? true: false );
  // useEffect(() => {
  //   handleMedicationChange(index, "default_timing_instruction", null);
  // }, [showAlternateTiming]);

  const saveDose = async () => {
    try {
      const data = {
        ...formData?.doses[0],
        is_save: 1,
        doctor_id: userData.id,
        name: formdata?.name,
        type_unit_ui: showAlternateTiming? "Alternate":"Default",
        company_name: formdata?.company_name,
        contain: formdata?.contain,
        _method: "put",
      };
      let result;
      result = await updatemedicine(formdata?.id, data);
      if (result?.success) {
        setDoseSaved(1);
        messageApi.open({
          type: "success",
          content: "Dose saved successfully!",
        });

        console.log("Form Data Submitted:", formData);
      } else {
        messageApi.error(result.error || "Something went wrong");
      }
    } catch (error) {
      messageApi.error(error.message || "Submission failed");
      console.log("catch error:", error);
    }
  };
  useEffect(() => {
    // ✅ Skip if no previous data (first mount)
    if (!prevFormData.current) {
      prevFormData.current = formData;
      console.log("first load data");
      return;
    }

    // ✅ Compare specific fields only
const oldDoses = prevFormData.current?.doses || [];
const newDoses = formData?.doses || [];


    const changed = JSON.stringify(oldDoses) !== JSON.stringify(newDoses);
    console.log("fiels changed", changed);

    if (changed) {
      setDoseSaved(0);
    }

    // ✅ Update previous data
    prevFormData.current = formData;
  }, [formData]);



  // Responsive styles
  const cardStyle = {
    padding: "2px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  };

  const titleStyle = {
    fontSize: "19.2px",
    fontWeight: "bold",
  };

  const labelStyle = {
    fontSize: screens.xs ? "19.2px" : "19.2px",
    fontWeight: "bold",
    marginBottom: screens.xs ? "6px" : "8px",
    display: "block",
    alignItems: "center",
  };

  const inputStyle = {
    fontSize: screens.xs ? "0.10rem" : "19.2px",
    fontWeight: "bold",
  };

  const buttonStyle = {
    fontSize: screens.xs ? "0.9rem" : "17.2px",
    height: screens.xs ? "28px" : "32px",
    padding: screens.xs ? "0 8px" : "0 12px",
    fontWeight: "bold",
  };

  const radioStyle = {
    fontSize: screens.xs ? "0.9rem" : "19.2px",
    marginBottom: screens.xs ? "6px" : "8px",
    fontWeight: "bold",
  };

  const scrollableFormStyle = {
    maxHeight: "100%",
    overflowY: "auto",
    overflowX: "hidden",
    padding: screens.xs ? "8px" : "12px 12px 12px 12px",
  };

const getEmptyMedicationDose = (prevDose) => ({
  quantity: "",
  type: prevDose?.type || "",
  default_timing: "",
  default_timing_instruction: {},
  duration: "",
  note: "",
  type_unit_ui: prevDose?.type_unit_ui || "Default",
  unit:
    prevDose?.unit ||
    dosageUnitMap[prevDose?.type]?.[0] ||
    "",
});

const handleAddDose = () => {
  setFormData((prev) => {
    const prevDoses = prev?.doses || [];
    const newDose = getEmptyMedicationDose(prevDoses[prevDoses.length - 1]);

    const updated = {
      ...prev, // ✅ keep other fields
      doses: [...prevDoses, newDose],
    };

    // ✅ select newly added dose safely
    setSelectedDoseIndex(prevDoses.length);

    // ✅ sync with parent
    onDataChange(type, title?.name, updated);

    return updated;
  });
};

  const handleRemoveDose = (index) => {
    const newData = formData?.doses?.filter((_, i) => i !== index);
    setFormData({ doses: newData });
    onDataChange(type, title?.name, { doses: newData });
    setSelectedDoseIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : 0));
  };
  const dosageUnitMap = {
    // Common Oral/Systemic Forms
    Tablet: ["Tablet(s)", "mg", "g", "Unit(s)", "mcg"],
    Capsule: ["Capsule(s)", "mg", "g", "Unit(s)", "mcg"],
    Powder: ["g", "mg", "Sachet(s)", "tsp", "tbsp", "Unit(s)"],
    Sachet: ["Sachet(s)", "g", "mg"],
    Granule: ["Pouch(s)", "g", "mg", "Sachet(s)"],
    Pill: ["Pill(s)"],
    Softule: ["Softule(s)"],
    Biscuit: ["Biscuit(s)"],
    Lozenger: ["Lozenger(s)"],

    // Liquid Oral/Systemic Forms
    Syrup: ["mL", "tsp", "tbsp", "Drop(s)", "Unit(s)"],
    Liquid: ["mL", "tsp", "tbsp", "Drop(s)", "Unit(s)"],
    Solution: ["mL", "Drop(s)", "Unit(s)"],
    "Oral Solution": ["mL", "Drop(s)"],
    Suspension: ["mL", "tsp", "tbsp", "Drop(s)"],
    Elixer: ["mL", "tsp", "tbsp"],
    Linctus: ["mL", "tsp", "tbsp"],
    Mouthwash: ["mL"],
    Gargle: ["mL"],
    Emulsion: ["mL"],
    Expectorant: ["mL"],
    Tincture: ["mL"],
    Concentrate: ["mL"],

    // Injectable/Intravenous Forms
    Injection: ["mL", "Unit(s)", "mg", "mcg"],
    Vial: ["Vial(s)", "Unit(s)", "mL", "mg"],
    Infusion: ["mL", "Unit(s)"],
    Injectable: ["mL", "Unit(s)", "mg"],
    "Injectable Foam": ["mL"],
    Vaccine: ["Dose(s)", "mL", "Unit(s)"],
    Cartridge: ["Cartridge(s)", "Unit(s)"],
    Pen: ["Unit(s)", "Dose(s)"],

    // Respiratory Forms
    Inhaler: ["Puff(s)"],
    Respule: ["Respule(s)", "mL"],
    "Oral Inhaler": ["Puff(s)"],
    Rotacap: ["Rotacap(s)"],
    Transcap: ["Transcap(s)"],
    Transhaler: ["Transhaler(s)"],
    Aerosol: ["Puff(s)", "mL"],
    Nebuliser: ["mL"],
    Spacer: ["Unit(s)"],

    // Topical/Local Forms
    Ointment: ["Fingertip Unit(s)", "Pea Sized", "g", "Tube(s)"],
    Cream: ["Fingertip Unit(s)", "Pea Sized", "g", "Tube(s)"],
    Lotion: ["mL", "Drop(s)", "Pump(s)"],
    Gel: ["Fingertip Unit(s)", "Pea Sized", "g", "Tube(s)"],
    Paste: ["g", "Tube(s)"],
    Balm: ["g"],
    Serum: ["Drop(s)", "mL"],
    Oil: ["mL", "Drop(s)"],
    Liniment: ["mL"],
    "Gum Paint": ["Drop(s)"],
    "Mouth Paint": ["Drop(s)"],
    Paint: ["Drop(s)"],
    Applicap: ["Applicap(s)"],
    Tube: ["Tube(s)", "g"],

    // Patches/Inserts
    Patch: ["Patch(es)", "Unit(s)"],
    "Cellular Sheet": ["Sheet(s)"],
    Film: ["Film(s)"],
    Ring: ["Ring(s)"],
    "Intrauterine Device": ["Device(s)"],
    Disc: ["Disc(s)"],
    Pessary: ["Pessary(ies)"],
    Suppository: ["Suppository(ies)"],
    Tampon: ["Tampon(s)"],
    Troche: ["Troche(s)"],
    Wafer: ["Wafer(s)"],

    // Miscellaneous/Hygiene/Device Forms
    Drop: ["Drop(s)", "mL"],
    Soap: ["Bar(s)"],
    "Face Wash": ["Pump(s)", "mL"],
    Shampoo: ["mL"],
    Conditioner: ["mL"],
    Toothpaste: ["g", "Tube(s)"],
    Enema: ["mL", "Kit(s)"],
    Kit: ["Kit(s)"],
    Device: ["Device(s)", "Unit(s)"],
    Dressing: ["Unit(s)", "Sheet(s)"],
    Strip: ["Strip(s)"],
    Mask: ["Mask(s)"],
    Shield: ["Shield(s)"],
    Other: ["Unit(s)", "As Directed"],

    // Specialized/Rare Forms (Units often standardized or N/A)
    Aplicap: ["Applicap(s)"],
    Bar: ["Bar(s)"],
    Glue: ["mL"],
    Hygiene: ["Unit(s)"],
    Jelly: ["g", "Tube(s)"],
    "Wash Kit": ["Kit(s)"],
    "Gum Astringent": ["Drop(s)"],
    Octocap: ["Octocap(s)"],
    Bead: ["Bead(s)"],
    Block: ["Block(s)"],
    Catheter: ["Unit(s)"],
    Cement: ["Unit(s)"],
    "Chewable Gel": ["Piece(s)"],
    Cigarette: ["Cigarette(s)"],
    Cloth: ["Unit(s)"],
    Cone: ["Cone(s)"],
    Core: ["Core(s)"],
    Crystal: ["g", "mg"],
    Culture: ["Unit(s)"],
    Diaphragm: ["Unit(s)"],
    Dosing: ["Unit(s)"],
    Douche: ["Unit(s)", "mL"],
    Extract: ["g", "mg"],
    Gas: ["Unit(s)"],
    Generator: ["Unit(s)"],
    Globule: ["Globule(s)"],
    Graft: ["Unit(s)"],
    Gum: ["Gum(s)"],
    Implant: ["Unit(s)"],
    Inhalant: ["Puff(s)", "mL"],
    Insert: ["Insert(s)"],
    Irrigant: ["mL"],
    Liner: ["Unit(s)"],
    Lipstick: ["Unit(s)"],
    Milk: ["mL"],
    "Not Applicable": ["Unit(s)"],
    Note: ["Unit(s)"],
    Packing: ["Unit(s)"],
    Pastille: ["Pastille(s)"],
    Pellet: ["Pellet(s)"],
    Plaster: ["Unit(s)"],
    Poultice: ["Unit(s)"],
    Rinse: ["mL"],
    Salve: ["g"],
    Sponge: ["Unit(s)"],
    Stick: ["Stick(s)"],
    Suture: ["Unit(s)"],
    Swab: ["Swab(s)"],
    System: ["Unit(s)"],
    Tape: ["Unit(s)"],
    Transpule: ["Transpule(s)", "mL"],
  };

  useEffect(() => {
    let initialData = {};
      if (!formdata) return;


    switch (type) {
      case "symptoms":
      case "findings":
        initialData = {
          note: formdata?.note || "",
          since: formdata?.since || " Day",
          severity: formdata?.severity || "",
        };
        break;
      case "medicines":
        if (formdata?.doses && Array.isArray(formdata?.doses)) {
          // 1. Prepare the structured data
          const structuredDoses = formdata.doses.map((attr) => ({
            quantity: attr?.quantity || "",
            type: attr?.type || "",
            default_timing: attr?.default_timing || "",
            default_timing_instruction: attr?.default_timing_instruction || "",
            type_unit_ui: attr?.type_unit_ui || "Default",
            duration: attr?.duration || "",
            unit: attr?.unit || "",
            note: attr?.note || "",
          }));

          initialData = { doses: structuredDoses };

          // 2. EXACT BUG FIX: Notify parent immediately for multiple doses
          onDataChange(type, title?.name, initialData);

          // 3. Update UI state
          setShowAlternateTiming(
            formdata.doses[0]?.type_unit_ui === "Alternate",
          );
        } else {
          // Single dose logic (This part was already calling onDataChange)
          initialData = {
            doses: [
              {
                quantity: formdata?.quantity || "",
                type: formdata?.type || "",
                type_unit_ui: formdata?.type_unit_ui || "Default",
                default_timing: formdata?.default_timing || "",
                unit:
                  formdata?.unit || dosageUnitMap[formdata?.type]?.[0] || "",
                default_timing_instruction:
                  formdata?.default_timing_instruction || "",
                duration: formdata?.duration || "",
                note: formdata?.note || "",
              },
            ],
          };
          onDataChange(type, title?.name, initialData);
          setShowAlternateTiming(formdata?.type_unit_ui === "Alternate");
        }
        break;
      case "diagnosis":
        initialData = {
          note: formdata?.note || "",
          location: formdata?.location || "",
          description: formdata?.description || "",
        };
        break;
      case "investigations":
        initialData = {
          note: formdata?.note || "",
          date_for_test: formdata?.date_for_test || "",
          repeat_test_every: formdata?.repeat_test_every || "",
        };
        break;
      case "procedures":
        initialData = {
          note: formdata?.note || "",
          date_time: formdata?.date_time || "",
          location: formdata?.location || "",
          indication: formdata?.indication || "",

          pre_op_advice: formdata?.pre_op_advice || "",
        };
        break;
    }

    setFormData(initialData);
    setSelectedDoseIndex(0);
}, [formdata, type, title?.name]);

  const handleChange = (field, value) => {
    const newData = { ...formData, [field]: value };
    setFormData(newData);
    onDataChange(type, title?.name, newData);
  };

  const handleMedicationChange = (index, field, value) => {
    const newData = { ...formData };
    console.log("New Data before change:", newData);
    newData.doses[index][field] = value;
    setFormData({ ...newData });
    onDataChange(type, title?.name, newData);
  };

  const handleNestedMedicationChange = (index, field, subfield, value) => {
    const newData = [...formData.dose];
    newData[index][field] = {
      ...newData[index][field],
      [subfield]: value,
    };
    setFormData(newData);
    onDataChange(type, title?.name, newData);
  };

  const renderSymptomOrSignForm = () => {
    const timeIntervalsData = [
      { display: "1 D", value: "1 Day" },
      { display: "2 D", value: "2 Days" },
      { display: "3 D", value: "3 Days" },
      { display: "4 D", value: "4 Days" },
      { display: "1 W", value: "1 Week" },
      { display: "2 W", value: "2 Weeks" },
      { display: "1 M", value: "1 Month" },
      { display: "3 M", value: "3 Months" },
      { display: "6 M", value: "6 Months" },
      { display: "1 Y", value: "1 Year" },
    ];
    const defaultSince = "1 Day"; // optional default value

    // 🧠 helper function to update value properly
    const handleSinceChange = (number, unit) => {
      const currentValue = formData.since || "  ";
      const parts = currentValue.split(" ");
      const num = number ?? parts[0] ?? "";
      const unt = unit ?? parts[1] ?? "Day";
      const combined = num ? `${num} ${unt}` : "";
      handleChange("since", combined);
    };
    const handleTimeButtonClick = (time) => {
      handleChange("since", time);
    };

    // Extract current parts for UI
const [sinceNumber, setSinceNumber] = useState("");
const [sinceUnit, setSinceUnit] = useState("Day"); // Default
useEffect(() => {
  if (formData?.since) {
    const [num, unit] = formData.since.split(" ");

    setSinceNumber(num || "");
    setSinceUnit(unit || "Day"); // Auto-select button
  }
}, [formData]);


    return (
      <div style={scrollableFormStyle}>
        <div style={{ marginBottom: screens.xs ? "12px" : "16px" }}>
          <div style={labelStyle}>Note</div>
          <TextArea
            placeholder="Enter note here..."
            rows={screens.xs ? 3 : 4}
            value={formData?.note || ""}
            onChange={(e) => handleChange("note", e.target.value)}
            style={inputStyle}
          />
        </div>

        {/* <div style={{ marginBottom: screens.xs ? "12px" : "16px" }}>
          <div style={labelStyle}>Since</div>
          <Select
            placeholder="Enter custom duration"
            style={{ width: "100%", ...inputStyle }}
            value={formData?.since || undefined}
            onChange={(value) => handleChange("since", value)}
          >
            <Select.Option value="1d">1 day</Select.Option>
            <Select.Option value="3d">3 days</Select.Option>
            <Select.Option value="1w">1 week</Select.Option>
            <Select.Option value="2w">2 weeks</Select.Option>
            <Select.Option value="1m">1 month</Select.Option>
          </Select>
        </div> */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: screens.xs ? "6px" : "8px",
            flexWrap: "wrap",
          }}
        >
          <Text strong style={labelStyle}>
            Since
          </Text>

          <div style={{ display: "flex", alignItems: "center" }}>
  {/* Number Input */}
  <Input
    type="number"
    placeholder="Enter number"
    value={sinceNumber || ""}
    onChange={(e) => {
        const newValue = e.target.value;
        
        // --- Core Logic to Handle Empty String ---
        // 1. Allow the value to be set if it's an empty string (user cleared the input).
        // 2. Allow the value to be set if it contains only digits.
        //    (The HTML type="number" usually handles non-digits, but this provides a safeguard).

        // We use regular expression to check if the value is either empty OR contains 1 or more digits.
        if (newValue === "" || /^\d+$/.test(newValue)) {
            setSinceNumber(newValue);
            handleSinceChange(newValue, null)
            
            // OPTIONAL: If you need to immediately update the form data, 
            // you'd call an update function here, using 'newValue' and 'sinceUnit'.
            // For example: 
            // updateFormData({ since: `${newValue} ${sinceUnit}` });
        }
    }}
    style={{
      width: "100px",
      height: "36px",
      border: "1px solid #d9d9d9",
      borderRight: "none",
      borderRadius: "4px 0 0 4px",
      padding: "6px 10px",
      outline: "none",
    }}
  />

  {/* Unit Buttons */}
  <div style={{ display: "flex" }}>
    {["Day", "Week", "Month", "Year"].map((unit) => (
      <button
        key={unit}
        onClick={() => handleSinceChange(null, unit)}
        style={{
          height: "36px",
          padding: "0 12px",
          border: "1px solid #d9d9d9",
          borderLeft: "none",
          backgroundColor: sinceUnit === unit ? "#1677ff" : "white",
          color: sinceUnit === unit ? "white" : "#000",
          cursor: "pointer",
          fontSize: "14px",
        }}
      >
        {unit}
      </button>
    ))}
  </div>
</div>

        </div>

        {/* Time Buttons */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: screens.xs ? "2px" : "4px",
            marginBottom: screens.xs ? "6px" : "8px",
          }}
        >
          {timeIntervalsData.map((time) => (
            <Button
              key={time}
              style={{
                ...buttonStyle,
                flex: screens.xs ? "1 0 18%" : "1 0 16%",
                backgroundColor:
                  formData?.since === time.value ? "#f0f7ff" : "white",
                borderColor:
                  formData?.since === time.value ? "#1890ff" : "#d9d9d9",
                color: formData?.since === time.value ? "#1890ff" : "inherit",
              }}
              onClick={() => handleTimeButtonClick(time.value)}
            >
              {time.display}
            </Button>
          ))}
        </div>

        <div>
          <div style={labelStyle}>Severity</div>

          <div
            style={{
              display: "flex",
              width: "100%",
              borderRadius: "30px",
              overflow: "hidden",
              border: "1px solid #d9d9d9",
            }}
          >
            {["mild", "moderate", "severe"].map((level) => (
              <button
                key={level}
                onClick={() => handleChange("severity", level)}
                style={{
                  flex: 1,
                  padding: "7px 0",
                  fontSize: "17.2px",
                  fontWeight: "bold",
                  border: "none",
                  background:
                    formData?.severity === level ? "#e6f4ff" : "white",
                  color: formData?.severity === level ? "#1677ff" : "#555",

                  borderRight:
                    level !== "severe" ? "1px solid #d9d9d9" : "none",
                  cursor: "pointer",
                }}
              >
                {level.charAt(0).toUpperCase() + level.slice(1)}
              </button>
            ))}
          </div>
        </div>
      </div>
    );
  };
  const renderInvestigations = () => {
    const timeIntervals = ["1 D", "3 D", "1 W", "2 W", "1 M"];
    const defaultSince = "1 Day"; // optional default value

    // 🧠 helper function to update value properly
    const handleSinceChange = (number, unit) => {
      const currentValue = formData.repeat_test_every || "";
      const parts = currentValue.split(" ");
      const num = number ?? parts[0] ?? "";
      const unt = unit ?? parts[1] ?? "Day";
      const combined = num ? `${num} ${unt}` : "";
      handleChange("repeat_test_every", combined);
    };

    // 🕐 (Optional) Button click handler, e.g. for quick presets
    const handleTimeButtonClick = (time) => {
      handleChange("repeat_test_every", time);
    };

    // 🧩 Extract current values for UI
    const [sinceNumber, sinceUnit] = (formData?.repeat_test_every || "").split(
      " "
    );

    return (
      <div style={scrollableFormStyle}>
        <div style={{ marginBottom: screens.xs ? "12px" : "16px" }}>
          <div style={labelStyle}>Date for Test</div>
          <DatePicker
            value={
              formData?.date_for_test
                ? dayjs(formData?.date_for_test, "YYYY-MM-DD")
                : null
            }
            onChange={(date, dateString) =>
              handleChange("date_for_test", dateString)
            }
            format="YYYY-MM-DD"
            style={{
              ...inputStyle,
              width: "100%",
            }}
            placeholder="Select test date"
          />
        </div>

        {/* <div style={{ marginBottom: screens.xs ? "12px" : "16px" }}>
          <div style={labelStyle}>Since</div>
          <Select
            placeholder="Enter custom duration"
            style={{ width: "100%", ...inputStyle }}
            value={formData?.since || undefined}
            onChange={(value) => handleChange("since", value)}
          >
            <Select.Option value="1d">1 day</Select.Option>
            <Select.Option value="3d">3 days</Select.Option>
            <Select.Option value="1w">1 week</Select.Option>
            <Select.Option value="2w">2 weeks</Select.Option>
            <Select.Option value="1m">1 month</Select.Option>
          </Select>
        </div> */}
        <div
          style={{
            // display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: screens.xs ? "6px" : "8px",
            flexWrap: "wrap",
          }}
        >
          <Text strong style={labelStyle}>
            Reapeat Test Every
          </Text>

          <div style={{ display: "flex", alignItems: "center" }}>
            <input
              type="number"
              placeholder="Enter number"
              value={sinceNumber || ""}
              onChange={(e) => handleSinceChange(e.target.value, null)}
              style={{
                width: "100px",
                height: "36px",
                border: "1px solid #d9d9d9",
                borderRight: "none",
                borderRadius: "4px 0 0 4px",
                padding: "6px 10px",
                outline: "none",
              }}
            />

            <select
              value={sinceUnit || "Day"}
              onChange={(e) => handleSinceChange(null, e.target.value)}
              style={{
                width: "90px",
                height: "36px",
                border: "1px solid #d9d9d9",
                borderRadius: "0 4px 4px 0",
                padding: "6px 10px",
                outline: "none",
                backgroundColor: "white",
              }}
            >
              <option value="Day">Day</option>
              <option value="Week">Week</option>
              <option value="Month">Month</option>
            </select>
          </div>
        </div>

        {/* Time Buttons */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: screens.xs ? "2px" : "4px",
            marginBottom: screens.xs ? "6px" : "8px",
          }}
        ></div>
        <div style={{ marginBottom: screens.xs ? "12px" : "16px" }}>
          <div style={labelStyle}>Note</div>
          <TextArea
            placeholder="Enter note here..."
            rows={screens.xs ? 3 : 4}
            value={formData?.note || ""}
            onChange={(e) => handleChange("note", e.target.value)}
            style={inputStyle}
          />
        </div>
      </div>
    );
  };
  const renderProcedures = () => {
    const timeIntervals = ["1 D", "3 D", "1 W", "2 W", "1 M"];
    const defaultSince = "1 Day"; // optional default value

    // 🧠 helper function to update value properly
    const handleSinceChange = (number, unit) => {
      const currentValue = formData.repeat_test_every || "";
      const parts = currentValue.split(" ");
      const num = number ?? parts[0] ?? "";
      const unt = unit ?? parts[1] ?? "Day";
      const combined = num ? `${num} ${unt}` : "";
      handleChange("repeat_test_every", combined);
    };

    // 🕐 (Optional) Button click handler, e.g. for quick presets
    const handleTimeButtonClick = (time) => {
      handleChange("repeat_test_every", time);
    };

    // 🧩 Extract current values for UI
    const [sinceNumber, sinceUnit] = (formData?.repeat_test_every || "").split(
      " "
    );

    return (
      <div style={scrollableFormStyle}>
        <div style={{ marginBottom: screens.xs ? "12px" : "16px" }}>
          <div style={labelStyle}>Date & Time</div>
          <DatePicker
            showTime={{ format: "hh:mm A" }}
            value={
              formData?.date_time
                ? // Try both formats (backend 24h and frontend 12h)
                  dayjs(formData.date_time, [
                    "YYYY-MM-DD HH:mm:ss", // from backend
                    "YYYY-MM-DD hh:mm A", // from frontend
                  ])
                : null
            }
            onChange={(date) => {
              // Always store in 12-hour format for display
              const formatted = dayjs(date).format("YYYY-MM-DD hh:mm A");
              handleChange("date_time", formatted);
            }}
            format="YYYY-MM-DD hh:mm A"
            style={{
              ...inputStyle,
              width: "100%",
            }}
            placeholder="Select date and time"
          />
        </div>

        {/* Time Buttons */}

        <div style={{ marginBottom: screens.xs ? "12px" : "16px" }}>
          <div style={labelStyle}>Location</div>
          <TextArea
            placeholder="Enter Location here..."
            rows={screens.xs ? 1 : 1}
            value={formData?.location || ""}
            onChange={(e) => handleChange("location", e.target.value)}
            style={inputStyle}
          />
        </div>
        <div style={{ marginBottom: screens.xs ? "12px" : "16px" }}>
          <div style={labelStyle}>Indication</div>
          <TextArea
            placeholder="Enter Indication here..."
            rows={screens.xs ? 1 : 1}
            value={formData?.indication || ""}
            onChange={(e) => handleChange("indication", e.target.value)}
            style={inputStyle}
          />
        </div>
        <div style={{ marginBottom: screens.xs ? "12px" : "16px" }}>
          <div style={labelStyle}>Note</div>
          <TextArea
            placeholder="Enter note here..."
            rows={screens.xs ? 3 : 4}
            value={formData?.note || ""}
            onChange={(e) => handleChange("note", e.target.value)}
            style={inputStyle}
          />
        </div>
      </div>
    );
  };

  const renderMedicationForm = () => {
    if (!formData?.doses || !Array.isArray(formData.doses)) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Please reselect the medicine....</div>;
  }

    const quantityOptions = ["½", "1", "1½", "2", "2½", "3", "4", "5"];

    const timingOptions = [
      "Before Food",
      "After Food",
      "Empty Stomach",
      "Bedtime",
    ];

    const durationDays = [
      "1d",
      "2d",
      "3d",
      "4d",
      "5d",
      "1w",
      "10d",
      "2w",
      "15d",
      "3w",
      "4w",
      "1m",
      "2m",
      "3m",
      "6m",
    ];
    const durationWeeks = ["1w", "10d", "2w", "15d", "3w"];
    const durationMonths = ["4w", "1m", "2m", "3m", "6m"];
    const statusOptions = ["SOS", "Till Require", "To Continue", "Stat"];
    const buttonBase = {
      flex: "2 0 20%",
      borderColor: "#d9d9d9",
      height: "30px",
      borderRadius: "6px",
    };
    // 🟢 Helper inside your component
    let currentIndex = 0;
    const handleDurationChange = (index, number, unit) => {
      currentIndex = index;
      const currentValue = formData.doses[index]?.duration || "";
      const parts = currentValue.split(" ");
      const num = number ?? parts[0] ?? "";
      const unt = unit ?? parts[1] ?? "Day";
      const combined = num ? `${num} ${unt}` : "";
      handleMedicationChange(index, "duration", combined);
    };

    const handleDurationButtonClick = (index, value) => {
      handleMedicationChange(index, "duration", value);
    };

    const [durationNumber, durationUnit] = (
      formData.doses[currentIndex]?.duration || ""
    ).split(" ");

    return (
      <div>
        {/* Dose Tabs */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: screens.xs ? "12px" : "16px",
            flexWrap: "wrap",
            gap: screens.xs ? "4px" : "8px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: screens.xs ? "4px" : "8px",
            }}
          >
            {formData?.doses?.map((dose, index) => (
              <Button
                key={index}
                type={selectedDoseIndex === index ? "primary" : "default"}
                onClick={() => {
                  setSelectedDoseIndex(index),
                    setShowAlternateTiming(
                      dose?.type_unit_ui == "Alternate" ? true : false
                    );
                }}
                style={{
                  ...buttonStyle,
                  backgroundColor:
                    selectedDoseIndex === index ? "#e6f7ff" : "transparent",
                  borderColor:
                    selectedDoseIndex === index ? "#1890ff" : "#d9d9d9",
                  color: selectedDoseIndex === index ? "#1890ff" : "inherit",
                }}
              >
                Dose {index + 1}
                {index > 0 && (
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemoveDose(index);
                    }}
                    style={{ marginLeft: "4px", cursor: "pointer" }}
                  >
                    ×
                  </span>
                )}
              </Button>
            ))}
          </div>
          <Button
            type="text"
            icon={<PlusOutlined style={{ color: "#1890ff" }} />}
            onClick={handleAddDose}
            style={buttonStyle}
          />
        </div>

        {formData?.doses?.map((dose, index) => (
          <div
            key={index}
            style={{ display: index === selectedDoseIndex ? "block" : "none" }}
          >
            {/* Quantity Section */}
            <div style={{ marginBottom: screens.xs ? "12px" : "16px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  WebkitJustifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: screens.xs ? "6px" : "8px",
                  flexWrap: "wrap",
                  gap: "8px",
                }}
              >
                <Text strong style={labelStyle}>
                  {dose?.type}
                </Text>
                <Select
                  value={
                    dose?.unit ||
                    (dose?.type && dosageUnitMap[dose?.type]
                      ? dosageUnitMap[dose?.type][0]
                      : "")
                  }
                  onChange={(value) =>
                    handleMedicationChange(index, "unit", value)
                  }
                  style={{ width: "150px", ...inputStyle }}
                >
                  {dosageUnitMap[dose?.type].map((unit) => (
                    <Option key={unit} value={unit}>
                      {unit}
                    </Option>
                  ))}
                </Select>
              </div>

              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: screens.xs ? "2px" : "4px",
                }}
              >
                {quantityOptions.map((qty) => (
                  <Button
                    key={qty}
                    style={{
                      flex: screens.xs ? "1 0 18%" : "1 0 10%",
                      fontSize: "17.2px",
                      fontWeight: "bold",
                      // minWidth: screens.xs ? "30px" : "40px",
                      backgroundColor:
                        dose?.quantity === qty ? "#f0f7ff" : "white",
                      borderColor:
                        dose?.quantity === qty ? "#1890ff" : "#d9d9d9",
                      color: dose?.quantityt === qty ? "#1890ff" : "inherit",
                    }}
                    onClick={() =>
                      handleMedicationChange(index, "quantity", qty)
                    }
                  >
                    {qty}
                  </Button>
                ))}
                <Input
                  type="number" // Restrict input to numbers
                  step="any" // Allows decimal input
                  value={
                    quantityOptions.includes(dose?.quantity)
                      ? ""
                      : dose?.quantity // Only show value if it's a custom/non-standard one
                  }
                  onChange={(e) =>
                    handleMedicationChange(index, "quantity", e.target.value)
                  }
                  placeholder="Dose"
                  style={{
                    flex: screens.xs ? "1 0 18%" : "1 0 10%",
                    fontSize: "17.2px",
                    fontWeight: "bold",
                    textAlign: "center", // Center the text to look like the buttons
                    // Apply the same conditional background/border style if a custom value is active
                    backgroundColor:
                      !quantityOptions.includes(dose?.quantity) &&
                      dose?.quantity
                        ? "#f0f7ff"
                        : "white",
                    borderColor:
                      !quantityOptions.includes(dose?.quantity) &&
                      dose?.quantity
                        ? "#1890ff"
                        : "#d9d9d9",
                    color:
                      !quantityOptions.includes(dose?.quantity) &&
                      dose?.quantity
                        ? "#1890ff"
                        : "inherit",
                    padding: screens.xs ? "0px 8px" : "0px 12px", // Adjust padding to match button height
                    height: "auto", // Match the height of the Button component
                  }}
                />
              </div>
            </div>

            {/* Timing Section */}
            {/* <div style={{ marginBottom: screens.xs ? "12px" : "16px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: screens.xs ? "6px" : "8px",
                  flexWrap: "wrap",
                  gap: "8px",
                }}
              >
                <Text strong style={labelStyle}>
                  Default Timing
                </Text>
                <Select
                  value={dose?.default_timing || ""}
                  onChange={(value) =>
                    handleMedicationChange(index, "default_timing", value)
                  }
                  style={{ width: "150px", ...inputStyle }}
                >
                  <Option value="Once a day">Once a day</Option>
                  <Option value="Twice a day">Twice a day</Option>
                  <Option value="Three times a day">Three times a day</Option>
                </Select>
              </div>

              
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: screens.xs ? "2px" : "4px",
                  marginBottom: screens.xs ? "6px" : "8px",
                }}
              >
                {timeIntervals.map((time) => (
                  <Button
                    key={time}
                    // style={{
                    //   ...buttonStyle,
                    //   flex: screens.xs ? "1 0 18%" : "1 0 16%",
                    //   backgroundColor: "white",
                    //   borderColor: "#d9d9d9",
                    // }}
                    style={{
                      ...buttonStyle,
                      flex: screens.xs ? "1 0 18%" : "1 0 16%",
                      backgroundColor:
                        dose?.default_timing === time ? "#f0f7ff" : "white",
                      borderColor:
                        dose?.default_timing === time ? "#1890ff" : "#d9d9d9",
                      color:
                        dose?.default_timing === time ? "#1890ff" : "inherit",
                    }}
                    onClick={() =>
                      handleMedicationChange(index, "default_timing", time)
                    }
                  >
                    {time}
                  </Button>
                ))}
              </div>

              
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: screens.xs ? "2px" : "4px",
                  marginBottom: screens.xs ? "8px" : "12px",
                }}
              >
                {frequencyOptions.map((freq) => (
                  <Button
                    key={freq}
                    style={{
                      ...buttonStyle,
                      flex: screens.xs ? "1 0 18%" : "1 0 16%",
                      backgroundColor:
                        dose?.default_timing === freq ? "#f0f7ff" : "white",
                      borderColor:
                        dose?.default_timing === freq ? "#1890ff" : "#d9d9d9",
                      color:
                        dose?.default_timing === freq ? "#1890ff" : "inherit",
                    }}
                    placeholder
                    onClick={() =>
                      handleMedicationChange(index, "default_timing", freq)
                    }
                  >
                    {freq}
                  </Button>
                ))}
              </div>

              
              <Radio.Group
                value={dose?.default_timing_instruction || ""}
                onChange={(e) =>
                  handleMedicationChange(
                    index,
                    "default_timing_instruction",
                    e.target.value
                  )
                }
                style={{ width: "100%" }}
              >
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: screens.xs ? "8px" : "12px",
                  }}
                >
                  {timingOptions.map((option) => (
                    <Radio key={option} value={option} style={radioStyle}>
                      {option}
                    </Radio>
                  ))}
                </div>
              </Radio.Group>
            </div> */}
            {/* -------------------------------------------------------------------------------------------------------------- */}
            <div style={{ marginBottom: screens.xs ? "12px" : "16px" }}>
              {/* Header */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: screens.xs ? "6px" : "8px",
                  flexWrap: "wrap",
                  gap: "8px",
                }}
              >
                {/* 🟢 Group label + Clear link together */}
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <Text strong style={labelStyle}>
                    Default Timing
                  </Text>
                  <span
                    onClick={() => {
                      handleMedicationChange(index, "default_timing", "");
                      handleMedicationChange(
                        index,
                        "default_timing_instruction",
                        ""
                      );
                    }}
                    style={{
                      ...labelStyle,
                      color: "green",
                      cursor: "pointer",
                      fontSize: "13px",
                      textDecoration: "underline",
                    }}
                  >
                    Clear
                  </span>
                </div>
                <span
                  onClick={() => {
                    handleMedicationChange(
                      index,
                      "default_timing_instruction",
                      null
                    ),
                      handleMedicationChange(
                        index,
                        "type_unit_ui",
                        showAlternateTiming ? "Default" : "Alternate"
                      ),
                      setShowAlternateTiming(!showAlternateTiming);
                  }} // Toggle the state
                  style={{
                    color: "#1890ff", // Blue color for the switch
                    cursor: "pointer",
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                >
                  Switch
                </span>

                {/* 🟢 Select on the right */}
                {/* <Select
                  value={dose?.default_timing || "Select Timing"}
                  onChange={(value) =>
                    handleMedicationChange(index, "default_timing", value)
                  }
                  style={{ width: "150px", ...inputStyle }}
                >
                  <Option value="Once">Once</Option>
                  <Option value="Twice">Twice</Option>
                  <Option value="Thrice">Thrice</Option>
                </Select> */}
              </div>

              {/* Meals Row */}
              {showAlternateTiming ? (
                // Renders the new UI based on the image
                <AlternateTimingUI
                  dose={dose}
                  index={index}
                  handleMedicationChange={handleMedicationChange}
                />
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "0px",
                    flexWrap: "wrap",
                  }}
                >
                  {["Breakfast", "Lunch", "Dinner"].map((meal) => {
                    const isSelected =
                      dose?.default_timing_instruction?.[meal] !== undefined;
                    const selectedInstruction =
                      dose?.default_timing_instruction?.[meal];

                    return (
                      <div
                        key={meal}
                        style={{
                          flex: "1 1 32%",
                          border: isSelected
                            ? "1px solid #1890ff"
                            : "1px solid #d9d9d9",
                          color: isSelected ? "#1890ff" : "inherit",
                          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                          transition: "all 0.2s",
                        }}
                      >
                        {/* Meal title */}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderBottom: "1px solid #d9d9d9",
                          }}
                        >
                          <Text
                            strong
                            style={{
                              color: isSelected ? "#1890ff" : "inherit",
                              fontSize: "15px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              // Toggle meal section on click
                              const updated = {
                                ...(dose.default_timing_instruction || {}),
                              };
                              if (updated[meal] !== undefined) {
                                delete updated[meal]; // deselect if clicked again
                              } else {
                                updated[meal] = null; // add meal key with null
                              }
                              handleMedicationChange(
                                index,
                                "default_timing_instruction",
                                updated
                              );
                            }}
                          >
                            {meal}
                          </Text>
                        </div>

                        {/* Before / After buttons */}

                        <div style={{ display: "flex" }}>
                          {["Before", "After"].map((option) => (
                            <div
                              key={option}
                              style={{
                                flex: 1,
                                textAlign: "center",
                                fontWeight: "bold",
                                borderTop:
                                  selectedInstruction === option
                                    ? "1px solid #1890ff"
                                    : "1px solid #d9d9d9",
                                borderRight:
                                  option === "Before" &&
                                  selectedInstruction === "Before"
                                    ? "1px solid #1890ff"
                                    : "1px solid #d9d9d9",
                                borderLeft:
                                  option === "After" &&
                                  selectedInstruction === "After"
                                    ? "1px solid #1890ff"
                                    : "1px solid #d9d9d9",
                                borderBottom: "none", // optional — makes it look cleaner

                                cursor: "pointer",
                                color:
                                  selectedInstruction === option
                                    ? "#1890ff"
                                    : "#555555",
                                backgroundColor:
                                  selectedInstruction === option
                                    ? "#f0f7ff"
                                    : "white",
                                fontSize: "14px",
                                padding: "6px 0",
                                transition: "0.2s",
                              }}
                              onClick={() => {
                                const updated = {
                                  ...(dose.default_timing_instruction || {}),
                                };
                                updated[meal] = option;
                                handleMedicationChange(
                                  index,
                                  "default_timing_instruction",
                                  updated
                                );
                              }}
                            >
                              {option}
                            </div>
                          ))}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            {/* Duration Section */}
            <div style={{ marginBottom: screens.xs ? "12px" : "16px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: screens.xs ? "6px" : "8px",
                  flexWrap: "wrap",
                }}
              >
                <Text strong style={labelStyle}>
                  Duration
                </Text>

                <div style={{ display: "flex", alignItems: "center" }}>
                  <input
                    type="number"
                    placeholder="Enter number"
                    value={durationNumber || ""}
                    onChange={(e) =>
                      handleDurationChange(index, e.target.value, null)
                    }
                    style={{
                      width: "100px",
                      height: "36px",
                      border: "1px solid #d9d9d9",
                      borderRight: "none",
                      borderRadius: "4px 0 0 4px",
                      padding: "6px 10px",
                      outline: "none",
                    }}
                  />

                  <select
                    value={durationUnit || "Day"}
                    onChange={(e) =>
                      handleDurationChange(index, null, e.target.value)
                    }
                    style={{
                      width: "90px",
                      height: "36px",
                      border: "1px solid #d9d9d9",
                      borderRadius: "0 4px 4px 0",
                      padding: "6px 10px",
                      outline: "none",
                      backgroundColor: "white",
                    }}
                  >
                    <option value="Day">Day</option>
                    <option value="Week">Week</option>
                    <option value="Month">Month</option>
                  </select>
                </div>
              </div>

              {/* Duration Buttons */}
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: screens.xs ? "2px" : "4px",
                  marginBottom: screens.xs ? "4px" : "6px",
                }}
              >
                {durationDays.map((day) => (
                  <Button
                    key={day}
                    style={{
                      ...buttonStyle,
                      flex: screens.xs ? "1 0 18%" : "1 0 16%",
                      backgroundColor:
                        dose?.duration === day ? "#f0f7ff" : "white",
                      borderColor:
                        dose?.duration === day ? "#1890ff" : "#d9d9d9",
                      color: dose?.duration === day ? "#1890ff" : "inherit",
                    }}
                    onClick={() => handleDurationButtonClick(index, day)}
                  >
                    {day}
                  </Button>
                ))}
              </div>

              {/* Status Options */}
              <Radio.Group
                value={dose?.duration || ""}
                onChange={(e) =>
                  handleMedicationChange(index, "duration", e.target.value)
                }
                style={{ width: "100%" }}
              >
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: screens.xs ? "8px" : "12px",
                  }}
                >
                  {statusOptions.map((option) => (
                    <Radio key={option} value={option} style={radioStyle}>
                      {option}
                    </Radio>
                  ))}
                </div>
              </Radio.Group>
            </div>

            {/* Note Section */}
            <div style={{ marginBottom: screens.xs ? "8px" : "12px" }}>
              <Text strong style={labelStyle}>
                Note
              </Text>
              <TextArea
                rows={screens.xs ? 3 : 4}
                value={dose?.note || ""}
                onChange={(e) =>
                  handleMedicationChange(index, "note", e.target.value)
                }
                placeholder="Enter note here..."
                style={inputStyle}
              />
            </div>
          </div>
        ))}
      </div>
    );
  };

  const renderConditionForm = () => {
    return (
      <div style={scrollableFormStyle}>
        <div style={{ marginBottom: screens.xs ? "12px" : "16px" }}>
          <div style={labelStyle}>Note</div>
          <TextArea
            placeholder="Enter note here..."
            rows={screens.xs ? 3 : 4}
            value={formData?.note || ""}
            onChange={(e) => handleChange("note", e.target.value)}
            style={inputStyle}
          />
        </div>

        <div style={{ marginBottom: screens.xs ? "12px" : "16px" }}>
          <div style={labelStyle}>Location</div>
          <TextArea
            placeholder="Enter location here"
            rows={screens.xs ? 3 : 4}
            value={formData?.location || ""}
            onChange={(e) => handleChange("location", e.target.value)}
            style={inputStyle}
          />
        </div>

        <div>
          <div style={labelStyle}>Description</div>
          <Radio.Group
            onChange={(e) => handleChange("description", e.target.value)}
            value={formData?.description || ""}
            style={{ width: "100%" }}
          >
            <div style={radioStyle}>
              <Radio value="to-rule-out">To rule out</Radio>
            </div>
            <div style={radioStyle}>
              <Radio value="suspected">Suspected</Radio>
            </div>
            <div style={radioStyle}>
              <Radio value="follow-up">Follow up</Radio>
            </div>
            <div style={radioStyle}>
              <Radio value="?">?</Radio>
            </div>
          </Radio.Group>
        </div>
      </div>
    );
  };

  const renderFormContent = () => {
    switch (type) {
      case "symptoms":
      case "findings":
        return renderSymptomOrSignForm();
      case "medicines":
        return renderMedicationForm();
      case "diagnosis":
        return renderConditionForm();
      case "investigations":
        return renderInvestigations();
      case "procedures":
        return renderProcedures();
      default:
        return null;
    }
  };

  // const detailFormImageLoaded = () => {
  //   if(type==="symptoms"){
  // }

  return (
    <div
      className="patient-list"
      style={{
        flex: 1,
        overflowY: "auto",

        overflowX: "hidden",
        height: "100%",
        scrollbarWidth: "thin",
        scrollbarColor: "#ccc transparent",
      }}
    >
      <div className="patient-details d-flex flex-column ">
        <Card
          title={
            <div>
              <div style={titleStyle}>
                {" "}
                {type == "symptoms" ? (
                  <FileSearchOutlined
                    style={{
                      color: "#FF4D4F",
                      fontSize: "20px",
                      marginRight: "5px",
                    }}
                  />
                ) : type == "findings" ? (
                  <SearchOutlined
                    style={{
                      color: "#FAAD14",
                      fontSize: "20px",
                      marginRight: "5px",
                    }}
                  />
                ) : type == "medicines" ? (
                  <MedicineBoxOutlined
                    style={{
                      color: "#52C41A",
                      fontSize: "20px",
                      marginRight: "5px",
                    }}
                  />
                ) : type == "diagnosis" ? (
                  <SolutionOutlined
                    style={{
                      color: "#1890FF",
                      fontSize: "20px",
                      marginRight: "5px",
                    }}
                  />
                ) : type == "investigations" ? (
                  <FileTextOutlined
                    style={{
                      color: "#13C2C2",
                      fontSize: "15px",
                      marginRight: "5px",
                    }}
                  />
                ) : type == "procedures" ? (
                  <ScissorOutlined
                    style={{
                      color: "#EB2F96",
                      fontSize: "15px",
                      marginRight: "5px",
                    }}
                  />
                ) : null}
                {title?.name}
              </div>
              {subtitle && (
                <div
                  style={{
                    fontSize: screens.xs ? "0.8rem" : "0.9rem",
                    color: "#999",
                  }}
                >
                  {subtitle}
                </div>
              )}
            </div>
          }
          extra={
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              {/* ⭐ Star Button (only for medicines) */}
              {type === "medicines" && (
                <button
                  onClick={saveDose}
                  style={{
                    background: "transparent",
                    border: "none",
                    padding: 0,
                    fontSize: "22px",
                    cursor: "pointer",
                    color: doseSaved ? "#f4c430" : "#888",
                  }}
                >
                  {doseSaved ? <StarFilled /> : <StarOutlined />}
                </button>
              )}

              {/* ❌ Close Button */}
              <button
                onClick={goToNextSection}
                style={{
                  background: "transparent",
                  border: "none",
                  padding: 0,
                  fontSize: "40px",
                  cursor: "pointer",
                }}
              >
                ×
              </button>
            </div>
          }
          style={cardStyle}
          bodyStyle={{ padding: "0px" }}
        >
          {renderFormContent()}
        </Card>
      </div>
    </div>
  );
};

export default MedicalForm;

MedicalForm.propTypes = {
  type: PropTypes.string.isRequired,
  title: PropTypes.object.isRequired,
  subtitle: PropTypes.string,
  onDataChange: PropTypes.func,
  formdata: PropTypes.object,
  goToNextSection: PropTypes.func,
};
